import { BlotterType } from 'models/blotters/BlotterType';
import type { IQuoteRequest } from 'models/secondaryMarket';

import type { Quote } from './quote.model';

export type SecondaryMarketQuoteActions =
  | SecondaryMarketQuoteRequested
  | SecondaryMarketQuoteReceived
  | SecondaryMarketQuoteFailed
  | SecondaryMarketQuoteRejected
  | SecondaryMarketQuoteCancelled
  | SecondaryMarketQuoteByIsinReloadRequested;

/////////////////////////////////////////////
export function secondaryMarketQuoteRequested(tabId: string, request: IQuoteRequest) {
  return {
    type: 'SECONDARY_MARKET_QUOTE_REQUESTED' as const,
    tabId,
    request,
  };
}

export type SecondaryMarketQuoteRequested = ReturnType<typeof secondaryMarketQuoteRequested>;

/////////////////////////////////////////////
export function secondaryMarketQuoteReceived(tabId: string, quoteId: string, data: Quote) {
  return {
    type: 'SECONDARY_MARKET_QUOTE_RECEIVED' as const,
    tabId,
    quoteId,
    data,
  };
}

export type SecondaryMarketQuoteReceived = ReturnType<typeof secondaryMarketQuoteReceived>;

/////////////////////////////////////////////

export function secondaryMarketQuoteRejected(tabId: string, ...errors: string[]) {
  return {
    type: 'SECONDARY_MARKET_QUOTE_REJECTED' as const,
    tabId,
    errors,
  };
}
export type SecondaryMarketQuoteRejected = ReturnType<typeof secondaryMarketQuoteRejected>;

/////////////////////////////////////////////

export function secondaryMarketQuoteFailed(tabId: string, quoteId: string | null, ...errors: string[]) {
  return {
    type: 'SECONDARY_MARKET_QUOTE_FAILED' as const,
    tabId,
    errors,
    quoteId,
  };
}
export type SecondaryMarketQuoteFailed = ReturnType<typeof secondaryMarketQuoteFailed>;

/////////////////////////////////////////////

export function secondaryMarketQuoteCancelled(tabId: string, quoteId: string | null | undefined) {
  return {
    type: 'SECONDARY_MARKET_QUOTE_CANCELLED' as const,
    tabId,
    quoteId,
  };
}
export type SecondaryMarketQuoteCancelled = ReturnType<typeof secondaryMarketQuoteCancelled>;

/////////////////////////////////////////////

export function secondaryMarketQuoteByIsinReloadRequested(isin: string, blotterType: BlotterType) {
  return {
    type: 'SECONDARY_MARKET_QUOTE_BY_ISIN_RELOAD_REQUESTED' as const,
    isin,
    blotterType,
  };
}
export type SecondaryMarketQuoteByIsinReloadRequested = ReturnType<typeof secondaryMarketQuoteByIsinReloadRequested>;

/////////////////////////////////////////////
